var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 41,
    viewBox: "0 0 135 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.984619,
    width: 134,
    height: 39,
    rx: 4.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.984619,
    width: 134,
    height: 39,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 22.2357C65.784 22.2357 63.867 24.0247 63.867 26.4887C63.867 28.9377 65.784 30.7417 68.136 30.7417C70.489 30.7417 72.406 28.9377 72.406 26.4887C72.405 24.0247 70.488 22.2357 68.136 22.2357ZM68.136 29.0677C66.847 29.0677 65.736 28.0047 65.736 26.4897C65.736 24.9587 66.848 23.9117 68.136 23.9117C69.425 23.9117 70.536 24.9587 70.536 26.4897C70.536 28.0037 69.425 29.0677 68.136 29.0677ZM58.822 22.2357C56.47 22.2357 54.553 24.0247 54.553 26.4887C54.553 28.9377 56.47 30.7417 58.822 30.7417C61.175 30.7417 63.092 28.9377 63.092 26.4887C63.092 24.0247 61.175 22.2357 58.822 22.2357ZM58.822 29.0677C57.533 29.0677 56.422 28.0047 56.422 26.4897C56.422 24.9587 57.534 23.9117 58.822 23.9117C60.111 23.9117 61.222 24.9587 61.222 26.4897C61.223 28.0037 60.111 29.0677 58.822 29.0677ZM47.744 23.5417V25.3457H52.062C51.933 26.3607 51.595 27.1017 51.079 27.6167C50.451 28.2447 49.468 28.9377 47.744 28.9377C45.086 28.9377 43.008 26.7947 43.008 24.1367C43.008 21.4787 45.086 19.3357 47.744 19.3357C49.178 19.3357 50.225 19.8997 50.998 20.6247L52.271 19.3517C51.191 18.3207 49.758 17.5317 47.744 17.5317C44.103 17.5317 41.042 20.4957 41.042 24.1367C41.042 27.7777 44.103 30.7417 47.744 30.7417C49.709 30.7417 51.192 30.0967 52.351 28.8887C53.543 27.6967 53.914 26.0207 53.914 24.6677C53.914 24.2497 53.882 23.8627 53.817 23.5407H47.744V23.5417ZM93.052 24.9427C92.698 23.9927 91.618 22.2357 89.411 22.2357C87.22 22.2357 85.399 23.9597 85.399 26.4887C85.399 28.8727 87.204 30.7417 89.62 30.7417C91.569 30.7417 92.697 29.5497 93.165 28.8567L91.715 27.8897C91.232 28.5987 90.571 29.0657 89.62 29.0657C88.67 29.0657 87.993 28.6307 87.558 27.7767L93.245 25.4247L93.052 24.9427ZM87.252 26.3607C87.204 24.7167 88.525 23.8797 89.476 23.8797C90.217 23.8797 90.845 24.2507 91.055 24.7817L87.252 26.3607ZM82.629 30.4847H84.497V17.9837H82.629V30.4847ZM79.567 23.1867H79.503C79.084 22.6867 78.278 22.2357 77.264 22.2357C75.137 22.2357 73.188 24.1047 73.188 26.5057C73.188 28.8897 75.137 30.7427 77.264 30.7427C78.279 30.7427 79.084 30.2917 79.503 29.7767H79.567V30.3887C79.567 32.0157 78.697 32.8857 77.296 32.8857C76.152 32.8857 75.443 32.0647 75.153 31.3717L73.526 32.0487C73.993 33.1757 75.233 34.5617 77.296 34.5617C79.487 34.5617 81.34 33.2727 81.34 30.1307V22.4947H79.568V23.1867H79.567ZM77.425 29.0677C76.136 29.0677 75.057 27.9877 75.057 26.5057C75.057 25.0067 76.136 23.9117 77.425 23.9117C78.697 23.9117 79.696 25.0067 79.696 26.5057C79.696 27.9877 78.697 29.0677 77.425 29.0677ZM101.806 17.9837H97.335V30.4847H99.2V25.7487H101.805C103.873 25.7487 105.907 24.2517 105.907 21.8667C105.907 19.4817 103.874 17.9837 101.806 17.9837ZM101.854 24.0087H99.2V19.7237H101.854C103.249 19.7237 104.041 20.8787 104.041 21.8667C104.041 22.8347 103.249 24.0087 101.854 24.0087ZM113.386 22.2137C112.035 22.2137 110.636 22.8087 110.057 24.1277L111.713 24.8187C112.067 24.1277 112.727 23.9017 113.418 23.9017C114.383 23.9017 115.364 24.4807 115.38 25.5097V25.6387C115.042 25.4457 114.318 25.1567 113.434 25.1567C111.649 25.1567 109.831 26.1377 109.831 27.9707C109.831 29.6437 111.295 30.7207 112.935 30.7207C114.189 30.7207 114.881 30.1577 115.315 29.4977H115.379V30.4627H117.181V25.6697C117.182 23.4517 115.524 22.2137 113.386 22.2137ZM113.16 29.0647C112.55 29.0647 111.697 28.7587 111.697 28.0027C111.697 27.0377 112.759 26.6677 113.676 26.6677C114.495 26.6677 114.882 26.8447 115.38 27.0857C115.235 28.2447 114.238 29.0647 113.16 29.0647ZM123.743 22.4867L121.604 27.9067H121.54L119.32 22.4867H117.31L120.639 30.0617L118.741 34.2757H120.687L125.818 22.4867H123.743ZM106.937 30.4847H108.802V17.9837H106.937V30.4847Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.7276C47.418 11.5656 47.1701 12.2326 46.673 12.7306C46.109 13.3226 45.3731 13.6186 44.4691 13.6186C43.6031 13.6186 42.8661 13.3186 42.2611 12.7186C41.6551 12.1176 41.3521 11.3736 41.3521 10.4856C41.3521 9.59656 41.6551 8.85256 42.2611 8.25256C42.8661 7.65156 43.6031 7.35156 44.4691 7.35156C44.8991 7.35156 45.3101 7.43556 45.7001 7.60256C46.0911 7.77056 46.404 7.99356 46.6381 8.27256L46.111 8.80056C45.714 8.32556 45.167 8.08856 44.468 8.08856C43.836 8.08856 43.29 8.31056 42.829 8.75456C42.368 9.19856 42.1381 9.77556 42.1381 10.4846C42.1381 11.1936 42.368 11.7706 42.829 12.2146C43.29 12.6586 43.836 12.8806 44.468 12.8806C45.138 12.8806 45.6971 12.6576 46.1441 12.2106C46.4341 11.9196 46.602 11.5146 46.647 10.9956H44.468V10.2746H47.375C47.405 10.4316 47.418 10.5826 47.418 10.7276Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 8.22162H49.2961V10.1236H51.7601V10.8446H49.2961V12.7466H52.0281V13.4846H48.5251V7.48462H52.0281V8.22162Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 13.4846H54.508V8.22162H52.832V7.48462H56.955V8.22162H55.279V13.4846Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 13.4846V7.48462H60.709V13.4846H59.938Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 13.4846H63.3572V8.22162H61.6812V7.48462H65.8042V8.22162H64.1281V13.4846Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.7096C73.0189 13.3156 72.2859 13.6186 71.4089 13.6186C70.5319 13.6186 69.7989 13.3156 69.2099 12.7096C68.6199 12.1036 68.3259 11.3616 68.3259 10.4846C68.3259 9.60761 68.6199 8.86561 69.2099 8.25961C69.7989 7.65361 70.5319 7.34961 71.4089 7.34961C72.2809 7.34961 73.0129 7.65461 73.6049 8.26361C74.1969 8.87261 74.4929 9.61261 74.4929 10.4846C74.4929 11.3616 74.1979 12.1036 73.6089 12.7096ZM69.7789 12.2066C70.2229 12.6566 70.7659 12.8806 71.4089 12.8806C72.0519 12.8806 72.5959 12.6556 73.0389 12.2066C73.4829 11.7566 73.7059 11.1826 73.7059 10.4846C73.7059 9.78661 73.4829 9.21261 73.0389 8.76261C72.5959 8.31261 72.0519 8.08861 71.4089 8.08861C70.7659 8.08861 70.2229 8.31361 69.7789 8.76261C69.3359 9.21261 69.1129 9.78661 69.1129 10.4846C69.1129 11.1826 69.3359 11.7566 69.7789 12.2066Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 13.4846V7.48462H76.513L79.429 12.1516H79.4619L79.429 10.9956V7.48462H80.1999V13.4846H79.3949L76.344 8.59062H76.3109L76.344 9.74662V13.4846H75.5749Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.7276C47.418 11.5656 47.1701 12.2326 46.673 12.7306C46.109 13.3226 45.3731 13.6186 44.4691 13.6186C43.6031 13.6186 42.8661 13.3186 42.2611 12.7186C41.6551 12.1176 41.3521 11.3736 41.3521 10.4856C41.3521 9.59656 41.6551 8.85256 42.2611 8.25256C42.8661 7.65156 43.6031 7.35156 44.4691 7.35156C44.8991 7.35156 45.3101 7.43556 45.7001 7.60256C46.0911 7.77056 46.404 7.99356 46.6381 8.27256L46.111 8.80056C45.714 8.32556 45.167 8.08856 44.468 8.08856C43.836 8.08856 43.29 8.31056 42.829 8.75456C42.368 9.19856 42.1381 9.77556 42.1381 10.4846C42.1381 11.1936 42.368 11.7706 42.829 12.2146C43.29 12.6586 43.836 12.8806 44.468 12.8806C45.138 12.8806 45.6971 12.6576 46.1441 12.2106C46.4341 11.9196 46.602 11.5146 46.647 10.9956H44.468V10.2746H47.375C47.405 10.4316 47.418 10.5826 47.418 10.7276Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 8.22162H49.2961V10.1236H51.7601V10.8446H49.2961V12.7466H52.0281V13.4846H48.5251V7.48462H52.0281V8.22162Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 13.4846H54.508V8.22162H52.832V7.48462H56.955V8.22162H55.279V13.4846Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 13.4846V7.48462H60.709V13.4846H59.938Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 13.4846H63.3572V8.22162H61.6812V7.48462H65.8042V8.22162H64.1281V13.4846Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.7096C73.0189 13.3156 72.2859 13.6186 71.4089 13.6186C70.5319 13.6186 69.7989 13.3156 69.2099 12.7096C68.6199 12.1036 68.3259 11.3616 68.3259 10.4846C68.3259 9.60761 68.6199 8.86561 69.2099 8.25961C69.7989 7.65361 70.5319 7.34961 71.4089 7.34961C72.2809 7.34961 73.0129 7.65461 73.6049 8.26361C74.1969 8.87261 74.4929 9.61261 74.4929 10.4846C74.4929 11.3616 74.1979 12.1036 73.6089 12.7096ZM69.7789 12.2066C70.2229 12.6566 70.7659 12.8806 71.4089 12.8806C72.0519 12.8806 72.5959 12.6556 73.0389 12.2066C73.4829 11.7566 73.7059 11.1826 73.7059 10.4846C73.7059 9.78661 73.4829 9.21261 73.0389 8.76261C72.5959 8.31261 72.0519 8.08861 71.4089 8.08861C70.7659 8.08861 70.2229 8.31361 69.7789 8.76261C69.3359 9.21261 69.1129 9.78661 69.1129 10.4846C69.1129 11.1826 69.3359 11.7566 69.7789 12.2066Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 13.4846V7.48462H76.513L79.429 12.1516H79.4619L79.429 10.9956V7.48462H80.1999V13.4846H79.3949L76.344 8.59062H76.3109L76.344 9.74662V13.4846H75.5749Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1019_6860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4359 8.02246C10.1449 8.33046 9.9729 8.80846 9.9729 9.42746V31.5435C9.9729 32.1635 10.1449 32.6405 10.4359 32.9485L10.5099 33.0205L22.8989 20.6315V20.4855V20.3395L10.5099 7.94946L10.4359 8.02246Z",
    fill: "url(#paint0_linear_1019_6860)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0279 24.7625L22.8989 20.6315V20.4855V20.3395L27.0289 16.2095L27.1219 16.2625L32.0149 19.0425C33.4119 19.8365 33.4119 21.1355 32.0149 21.9305L27.1219 24.7105L27.0279 24.7625Z",
    fill: "url(#paint1_linear_1019_6860)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1019_6860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1218 24.7096L22.8978 20.4856L10.4358 32.9486C10.8958 33.4366 11.6568 33.4966 12.5138 33.0106L27.1218 24.7096Z",
    fill: "url(#paint2_linear_1019_6860)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1218 16.2616L12.5138 7.96156C11.6568 7.47456 10.8958 7.53556 10.4358 8.02356L22.8988 20.4866L27.1218 16.2616Z",
    fill: "url(#paint3_linear_1019_6860)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1019_6860",
    x: 9.9729,
    y: 7.62549,
    width: 23.0898,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1019_6860"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1019_6860",
    result: "effect2_innerShadow_1019_6860"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1019_6860",
    x: 10.4358,
    y: 20.4856,
    width: 16.686,
    height: 12.8606,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1019_6860"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1019_6860",
    x1: 21.8007,
    y1: 9.19346,
    x2: 5.0187,
    y2: 25.9755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1019_6860",
    x1: 33.8334,
    y1: 20.4855,
    x2: 9.63753,
    y2: 20.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1019_6860",
    x1: 24.8279,
    y1: 22.7795,
    x2: 2.06939,
    y2: 45.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1019_6860",
    x1: 7.29719,
    y1: 0.661364,
    x2: 17.4595,
    y2: 10.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/GooglePlayLogo.44df2f5d48f442ee6439863e68885166.svg";
export { ForwardRef as ReactComponent };